import React from 'react';
import { OptionPill } from './QuestionOption';
import { TextDir } from './TextDir';
export const SimpleOption = ({ onClick, disabled, value, }) => (React.createElement(OptionPill, { disabled: disabled, size: "small", onClick: onClick, "data-testid": "simple-option" },
    React.createElement(TextDir, null, value)));
